export const NO_DATA_MESSAGE = 'No data available'
export const SERVER_ERROR = 'Server error'
export const NO_MATCHES = 'No matches'
